import { Button, Flex, Typography } from "antd";
import { Component, ReactNode } from "react";
import { translate } from "shared/languages";
import { colors } from "shared/theme/color";
import { textPx } from "shared/constants/zoom";

/**
 * Catches a render error below it, a lazily loaded view that failed to load
 * in particular, and shows a card with a reload button instead of a blank
 * page (System Review B29). importChunk (shared/utils/appVersion) already
 * reloads once on a chunk that disappeared after a deploy; this covers the
 * case its 30-second guard lets through, a genuinely broken or unreachable
 * file, where the page used to render nothing at all.
 */
class ChunkErrorBoundary extends Component<
  { children: ReactNode },
  { failed: boolean }
> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: unknown) {
    console.error("[ChunkErrorBoundary]", error);
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <Flex
        vertical
        align="center"
        justify="center"
        gap={8}
        style={{ padding: "80px 16px", textAlign: "center" }}
      >
        <Typography.Text strong style={{ fontSize: textPx(16), color: colors.ink }}>
          {translate("chunk_error.title")}
        </Typography.Text>
        <Typography.Text style={{ fontSize: textPx(13.5), color: colors.ink2 }}>
          {translate("chunk_error.body")}
        </Typography.Text>
        <Button
          type="primary"
          style={{ marginTop: 12 }}
          onClick={() => window.location.reload()}
        >
          {translate("chunk_error.reload")}
        </Button>
      </Flex>
    );
  }
}

export default ChunkErrorBoundary;
